function navigationFixed (): void {
    document.body.classList.add('page-navigation-fixed')
    document.body.scrollIntoView()
}
navigationFixed();